import Vue from "vue";
import VueI18n from "vue-i18n";
import messages from "../locales";

Vue.use(VueI18n);

const i18n = new VueI18n({
  locale: process.env.VUE_APP_LANGS.split(",").includes(
    localStorage.getItem("currentLang")
  )
    ? localStorage.getItem("currentLang")
    : process.env.VUE_APP_DEFAULT_LANG,
  messages,
  missing: (locale, key, vm) => {
    // Return a default value for missing keys
    if (key.indexOf("Titles.") !== -1) {
      const defaultTitleTail = key.split(".").slice(0, -1);
      return messages[process.env.VUE_APP_INSTALLATION][defaultTitleTail[0]][
        defaultTitleTail[1]
      ].default; // or return a default translation
    }

    return key;
  },
});

export default i18n;
